module.exports = __webpack_public_path__ + "static/media/app-store-badge.2cfdd0a7.svg";